import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { showDangerToast } from '../../constants/toaster'
import { useState, useEffect } from 'react'
import { s3 } from '../../constants/awsConfig'
import { useDispatch, useSelector } from 'react-redux'
import { updateLoading } from '../../../redux/features/common/commonSlice'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'

export const AddProductCategory = props => {
  const [isChangeStarted, setisChangeStarted] = useState(false);
  const [imageFileData, setImageFileData] = useState(null)
  const [parentCategories, setParentCategories] = useState([]);
  const userData = useSelector((state) => state?.userData);
  const dispatch = useDispatch();
  // Add state for parent category selection if not already in tagFormData
  const handleParentCategoryChange = (event, newValue) => {
    props.setTagFormData({
      ...props.tagFormData,
      parentId: newValue ? (newValue.id || newValue.uuid) : ''
    });
  };
  const handleSubmit = async () => {
    if (props?.tagFormData?.id) {
      if (props?.tagFormData?.categoryName) {
        if (imageFileData) {
          dispatch(updateLoading(true))
          const uploadedFile = await uploadImageFile(imageFileData)
          dispatch(updateLoading(false))
          props?.onSubmit(uploadedFile)
        }
        props?.onSubmit()
      } else {
        showDangerToast("Name is requried.")
      }

    } else {
      if (props?.tagFormData?.categoryName) {
        if (imageFileData) {
          dispatch(updateLoading(true))
          const uploadedFile = await uploadImageFile(imageFileData)
          dispatch(updateLoading(false))
          props?.setTagFormData({
            ...props?.tagFormData,
            categoryImage: uploadedFile
          })
          props?.onSubmit(uploadedFile)
        } else {
          showDangerToast("Icon is requried.")
        }

      } else {
        showDangerToast('Category name is required.')
      }


    }
  }



  const uploadImageFile = async assetFile => {
    if (!assetFile) return;

    const params = {
      Bucket: 'supa-dev-bucket', // bucket name
      Key: `uploads/${assetFile.name}`,
      Body: assetFile,
      ContentType: assetFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      console.log('Upload Success', data.Location);
      const url = data.Location.replace(
        "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
        "https://d2up68x544gew2.cloudfront.net/"
      );
      console.log(url, 'url');
      return url
    } catch (error) {
      console.error('Error uploading file:', error);
      return ''
    }
  }

  const handleTagName = (e) => {
    // let value = e.target.value.replace(/\s{2,}/g, ' ').trim();
    setisChangeStarted(true);
    props.setTagFormData({
      ...props?.tagFormData,
      categoryName: e.target.value
    });
  };

  const handleImageSelect = event => {
    const file = event.target.files[0]
    setImageFileData(file)
  }

  const callParentCategoryApi = async () => {
    try {
      dispatch(updateLoading(true));
      let path = urls.productCategoryKeyValuePair;
      let res = await ApiCaller.get({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200 || response.status == '200') {
        const categories = response.data.map(item => ({
          uuid: item.key,
          name: item.value
        }));
        setParentCategories(categories);
        dispatch(updateLoading(false));
      } else {
        dispatch(updateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error(error);
      showDangerToast(error.message);
    }
  }

  useEffect(() => {
    if (props.show) {
      callParentCategoryApi()
    }
  }, [props.show]);

  // Ensure parentId is set in tagFormData when parentCategories are loaded and modal is shown
  // useEffect(() => {
  //   if (props.show && parentCategories.length > 0 && !props.tagFormData.parentId) {
  //     props.setTagFormData({
  //       ...props.tagFormData,
  //       parentId: parentCategories[0].uuid
  //     });
  //   }
  // }, [props.show, parentCategories]);



  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          {props?.tagFormData?.id ? 'Update Product Category' : 'Add Product Category'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6 mb-3">
            <Form.Control
              value={props.tagFormData.categoryName}
              onChange={e => handleTagName(e)}
              placeholder='Enter Category Name'
              maxLength={75}
              aria-label='Small'
              aria-describedby='inputGroup-sizing-sm'
            />
            {props?.tagFormData?.categoryName ? (
              <></>
            ) : (
              <>
                {isChangeStarted && <label className='custom-error-label'>Category Name is required*</label>}
              </>
            )}
          </div>
          <div className='col-md-6 mb-3'>
            <input type='file' accept={'image/*'} onChange={(event) => handleImageSelect(event)} />
          </div>
          <div className="col-md-6 mb-3">
            <Autocomplete
              options={parentCategories}
              getOptionLabel={(option) => option.name || ''}
              value={
                parentCategories.find(
                  (cat) => (cat.id || cat.uuid) === props.tagFormData.parentId
                ) || null
              }
              onChange={handleParentCategoryChange}
              renderInput={(params) => (
                <TextField {...params} label="Select Parent Category" placeholder="Select Parent Category" variant="outlined" />
              )}
              isOptionEqualToValue={(option, value) => (option.id || option.uuid) === (value.id || value.uuid)}
            />
          </div>
          {/* Product and Service Enable Checkboxes */}
          <div className="col-md-6 mb-3">
            <div className="d-flex flex-row align-items-center gap-4" style={{ minHeight: 38 }}>
              <Form.Check
                type="checkbox"
                id="product-enable-checkbox"
                label={<span style={{ minWidth: 80, display: 'inline-block' }}>Product</span>}
                checked={!!props.tagFormData.productEnable}
                onChange={e => props.setTagFormData({
                  ...props.tagFormData,
                  productEnable: e.target.checked
                })}
                className="me-4"
              />
              <Form.Check
                type="checkbox"
                id="service-enable-checkbox"
                label={<span style={{ minWidth: 80, display: 'inline-block' }}>Service</span>}
                checked={!!props.tagFormData.serviceEnable}
                onChange={e => props.setTagFormData({
                  ...props.tagFormData,
                  serviceEnable: e.target.checked
                })}
              />
            </div>
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant='outlined' onClick={() => {
          setisChangeStarted(false);
          props.onHide();
        }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  )
}
